import type { PromotedPrice } from '@/domain/prices/promoted-price/types'
import type { PromotedPriceApiResponse } from './types'

export interface PromotedPriceResponseMapper {
  map: (response: PromotedPriceApiResponse) => PromotedPrice
}

export function createPromotedPriceResponseMapper(): PromotedPriceResponseMapper {
  function map(response: PromotedPriceApiResponse): PromotedPrice {
    const {
      accommodationId,
      duration,
      includedServices,
      featuredFilters,
      price,
      yieldCampaignLogo,
      yieldCampaignCode,
      departureDate,
      acmInformation,
      outboundDepartureAirportName,
      paymentMethod,
      yieldCampaignCountDown,
    } = response

    return {
      accommodationId,
      duration,
      services: includedServices,
      filters: featuredFilters,
      price: {
        value: price.value,
        originalValue: price.originalValue,
        discountPercentage: price.discountPercentage,
        supportText: price.legend,
      },
      departureDate: {
        date: departureDate.raw,
        formatted: departureDate.humanized,
      },
      transportType: acmInformation.transportType,
      mealplan: acmInformation.mealplanCode,
      acm: acmInformation,
      departureAirport: outboundDepartureAirportName,
      ...(yieldCampaignLogo && { campaignImage: yieldCampaignLogo }),
      ...(yieldCampaignCode && { campaignId: yieldCampaignCode }),
      ...(yieldCampaignCountDown && { campaignCountDown: yieldCampaignCountDown }),
      paymentMethod,
    }
  }

  return {
    map,
  }
}
